"use strict";
// Copyright © Veeam Software Group GmbH
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.headerCellRenderer = exports.headerResizeIndicatorId = exports.headerSortIndicatorId = exports.headerTextId = exports.headerCellId = exports.SortIndicator = exports.StyledSortIndicator = exports.HeaderResizeIndicator = exports.HeaderSortIndicator = exports.HeaderLabel = exports.HeaderText = exports.HeaderCell = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importStar(require("styled-components"));
const helpers_1 = require("../../helpers");
const features_1 = require("../features");
const Svg = __importStar(require("../svg"));
const types_1 = require("../types");
const trimmedTextRenderer_1 = require("./trimmedTextRenderer");
exports.HeaderCell = styled_components_1.default.div `
    height: ${helpers_1.SPACING_XL};
    width: 100%;

    position: relative;

    &:hover {
        background-color: ${(props) => {
    if (props.isSortable) {
        if (props.disabled) {
            return null;
        }
        return props.theme.colorHighlightLight;
    }
    return null;
}};
    }

    &:active {
        background-color: ${(props) => {
    if (props.isSortable) {
        if (props.disabled) {
            return props.theme.colorBackgroundDisabled;
        }
        return props.theme.colorHighlightDark;
    }
    return null;
}};
    }
`;
const justifyContentCss = ({ justify }) => {
    switch (justify) {
        case types_1.GRID_COLUMN_JUSTIFY.center:
            return (0, styled_components_1.css) `
                justify-content: center;
            `;
        case types_1.GRID_COLUMN_JUSTIFY.right:
            return (0, styled_components_1.css) `
                justify-content: end;
            `;
        default:
            return (0, styled_components_1.css) `
                justify-content: start;
            `;
    }
};
exports.HeaderText = styled_components_1.default.div `
    display: flex;
    max-width: 100%;
    min-width: 0;
    ${({ hasMarginRight }) => hasMarginRight &&
    (0, styled_components_1.css) `
            margin-right: ${helpers_1.SPACING_L};
        `}
`;
exports.HeaderLabel = styled_components_1.default.div `
    padding: ${helpers_1.SPACING_S} 0 ${helpers_1.SPACING_S} ${helpers_1.SPACING_S};
    color: ${({ theme }) => theme.colorTextMain};
    box-sizing: border-box;

    display: flex;
    ${justifyContentCss};

    height: 100%;
    width: 100%;
    user-select: none;

    color: ${({ disabled, theme }) => disabled && theme.colorTextLight};

    ${({ disabled, isInteractive, theme }) => !disabled &&
    isInteractive &&
    (0, styled_components_1.css) `
            &:hover {
                background-color: ${theme.colorHighlightLight};
            }

            &:active {
                background-color: ${theme.colorHighlightDark};
            }
        `}
`;
exports.HeaderSortIndicator = styled_components_1.default.div `
    display: flex;
    min-width: ${helpers_1.SPACING_L};

    ${({ disabled, theme }) => disabled &&
    (0, styled_components_1.css) `
            polygon {
                fill: ${theme.colorControlIconDisabled};
            }
        `}
`;
exports.HeaderResizeIndicator = styled_components_1.default.div `
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    width: 8px;

    cursor: col-resize;

    &:hover,
    &:active {
        background-color: ${(props) => props.theme.colorHighlightDark};
    }
`;
exports.StyledSortIndicator = styled_components_1.default.div `
    display: flex;
    height: ${helpers_1.SPACING_M};
    padding-left: ${helpers_1.SPACING_S};
`;
const SortIndicator = ({ direction }) => (react_1.default.createElement(exports.StyledSortIndicator, null,
    direction === 'asc' && react_1.default.createElement(Svg.asc, null),
    direction === 'desc' && react_1.default.createElement(Svg.desc, null)));
exports.SortIndicator = SortIndicator;
exports.headerCellId = 'grid-header-cell';
exports.headerTextId = 'grid-header-text';
exports.headerSortIndicatorId = 'grid-header-sort-indicator';
exports.headerResizeIndicatorId = 'grid-header-resize-indicator';
const headerCellRenderer = (_a) => {
    var { cellData, onHeaderClick, headerJustify, columnKey, columnWidth, columnField, columnMinWidth, columnId } = _a, props = __rest(_a, ["cellData", "onHeaderClick", "headerJustify", "columnKey", "columnWidth", "columnField", "columnMinWidth", "columnId"]);
    const { state: { sort, resizable, disabled } } = (0, features_1.useGridContext)();
    const { onResizeToggleDown } = (0, features_1.useGridResizableContext)();
    const isSortable = !!sort;
    const isSortActive = sort && sort.key === columnField;
    return (react_1.default.createElement(exports.HeaderCell, { onClick: () => {
            if (onHeaderClick && !disabled)
                onHeaderClick();
        }, isSortable: isSortable && typeof onHeaderClick === 'function', disabled: disabled, "data-selector-id": exports.headerCellId },
        react_1.default.createElement(exports.HeaderLabel, { disabled: disabled, isInteractive: !!isSortActive, justify: headerJustify },
            headerJustify === types_1.GRID_COLUMN_JUSTIFY.right && (react_1.default.createElement("div", { style: { flexGrow: 1, display: 'flex' } })),
            props.contentRenderer ? (props.contentRenderer()) : (react_1.default.createElement(exports.HeaderText, { "data-selector-id": exports.headerTextId, hasMarginRight: !isSortActive }, (0, trimmedTextRenderer_1.trimmedTextRenderer)({
                cellData,
                columnWidth,
                bold: true,
                disabled
            }))),
            isSortActive && (react_1.default.createElement(exports.HeaderSortIndicator, { "data-selector-id": exports.headerSortIndicatorId, disabled: disabled },
                react_1.default.createElement(exports.SortIndicator, { direction: sort && sort.direction })))),
        resizable && !disabled && (react_1.default.createElement(exports.HeaderResizeIndicator, { "data-selector-id": exports.headerResizeIndicatorId, onMouseDown: (e) => onResizeToggleDown === null || onResizeToggleDown === void 0 ? void 0 : onResizeToggleDown(e, {
                key: columnKey,
                width: columnWidth,
                minWidth: columnMinWidth,
                columnId
            }) }))));
};
exports.headerCellRenderer = headerCellRenderer;
//# sourceMappingURL=headerCellRenderer.js.map